module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PH-e80661dae0b8974b342f3d598c616543.png";